import React, { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useTenant from "../../../../hooks/useTenant";
import useAuth from "../../../../hooks/useAuth";
import MenuCard from "./MenuCard";

function MenuAclFields(props) {
  const {
    fields,
    selectedPermissions,
    setSelectedPermissions,
    adminUserName,
    oldUserMenus,
    isMapUser,
  } = props;
  const { user, getUserMenusWithId, getUserMenusWithRoleId } = useAuth();
  const [menuResults, setMenuResults] = useState([]);

  console.log(adminUserName, "selectedPermissions.....");

  const { getTenant, tenant: tenantDetails } = useTenant();

  const { t } = useTranslation();
  const {
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();

  const assignedTo = watch("assignedTo");

  console.log(assignedTo, "tenant9090");

  useEffect(() => {
    if (!isMapUser && assignedTo != null && Object.keys(assignedTo).length != 0) {
      getTenant(assignedTo.value);
    }
  }, [assignedTo, isMapUser]);

  const fetchMenuDetails = async () => {
    if (isMapUser || (tenantDetails != null && Object.keys(tenantDetails).length != 0)) {
      const menuDetails = await getUserMenusWithRoleId(1);

      // Helper function to extract permissions from a menu list into a map
      const extractPermissions = (menus) => {
        const permissions = {};
        menus.forEach((menu) => {
          if (menu.checkedPermission && menu.checkedPermission[0]) {
            Object.assign(permissions, menu.checkedPermission[0]);
          }
          if (menu.children) {
            menu.children.forEach((child) => {
              if (child.checkedPermission) {
                child.checkedPermission.forEach((perm) => {
                  Object.assign(permissions, perm);
                });
              }
            });
          }
        });
        return permissions;
      };

      // Helper function to apply permissions to the target menu list
      const applyPermissions = (menus, permissionMap) => {
        return menus.map((menu) => {
          const newMenu = { ...menu };
          // Update parent permissions
          if (newMenu.checkedPermission && newMenu.checkedPermission[0]) {
            const permObj = newMenu.checkedPermission[0];
            Object.keys(permObj).forEach((key) => {
              if (permissionMap.hasOwnProperty(key)) {
                permObj[key] = permissionMap[key];
              }
            });
          }
          // Update children permissions
          if (newMenu.children) {
            newMenu.children = newMenu.children.map((child) => {
              const newChild = { ...child };
              if (newChild.checkedPermission) {
                newChild.checkedPermission = newChild.checkedPermission.map((perm) => {
                  const newPerm = { ...perm };
                  Object.keys(newPerm).forEach((key) => {
                    if (permissionMap.hasOwnProperty(key)) {
                      newPerm[key] = permissionMap[key];
                    }
                  });
                  return newPerm;
                });
              }
              return newChild;
            });
          }
          return newMenu;
        });
      };

      // 1. Extract existing permissions from oldUserMenus
      const oldPermissions = oldUserMenus ? extractPermissions(oldUserMenus) : {};

      // 2. Apply old permissions to the fresh role-based menu structure
      const mergedMenuDetails = applyPermissions(menuDetails, oldPermissions);

      console.log(mergedMenuDetails, "mergedMenuDetails with preserved permissions");
      setMenuResults(mergedMenuDetails);
    }
  };

  useEffect(() => {
    if (
      user != null &&
      (isMapUser || (tenantDetails != null && Object.keys(tenantDetails).length != 0))
    ) {
      fetchMenuDetails();
    }
  }, [tenantDetails, oldUserMenus, isMapUser, user]);

  return (
    <MenuCard
      menuResults={menuResults}
      selectedPermissions={selectedPermissions}
      setSelectedPermissions={setSelectedPermissions}
    />
  );
}

export default MenuAclFields;
